import React from 'react';
import TelegramConfig from '../components/TelegramConfig';
import TaxCalendarManager from '../components/TaxCalendarManager';
import ActivityTemplateManager from '../components/ActivityTemplateManager';
import CatalogoImpuestos from '../components/CatalogoImpuestos';
import { useAuth } from '../context/AuthContext';

const Settings = () => {
  const { user } = useAuth();
  const isAdmin = user?.role === 'Administrador';

  return (
    <div className="space-y-6" data-testid="settings-page">
      <div>
        <h1 className="text-4xl tracking-tight font-bold text-slate-900" style={{ fontFamily: 'Outfit' }}>
          Configuracion
        </h1>
        <p className="text-sm text-slate-700 leading-relaxed mt-2">Preferencias y notificaciones</p>
      </div>

      {/* User Info */}
      <div className="bg-white border border-slate-200 rounded-lg shadow-sm p-6">
        <h2 className="text-lg font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit' }}>Mi Perfil</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
          <div>
            <p className="text-xs font-semibold tracking-wider uppercase text-slate-500">Nombre</p>
            <p className="text-slate-900 mt-0.5">{user?.name}</p>
          </div>
          <div>
            <p className="text-xs font-semibold tracking-wider uppercase text-slate-500">Email</p>
            <p className="text-slate-900 mt-0.5">{user?.email}</p>
          </div>
          <div>
            <p className="text-xs font-semibold tracking-wider uppercase text-slate-500">Rol</p>
            <p className="text-slate-900 mt-0.5">{user?.role}</p>
          </div>
        </div>
      </div>

      {/* Catálogo Maestro de Impuestos - Admin Only */}
      {isAdmin && (
        <div className="bg-white border border-slate-200 rounded-lg shadow-sm p-6">
          <CatalogoImpuestos />
        </div>
      )}

      {/* Tax Calendar Manager - Admin Only */}
      {isAdmin && (
        <div className="bg-white border border-slate-200 rounded-lg shadow-sm p-6">
          <TaxCalendarManager />
        </div>
      )}

      {/* Activity Templates - Admin Only */}
      {isAdmin && (
        <div className="bg-white border border-slate-200 rounded-lg shadow-sm p-6">
          <ActivityTemplateManager />
        </div>
      )}

      {/* Telegram Config */}
      <div className="bg-white border border-slate-200 rounded-lg shadow-sm p-6">
        <TelegramConfig />
      </div>
    </div>
  );
};

export default Settings;
